import { katTranslator } from '../../shared/i18n';

const strings = {
  no_options: {
    'ar-SA': 'لم يتم العثور على نتائج.',
    'cs-CZ': 'Nebyly Nalezeny Žádné Výsledky.',
    'de-DE': 'Keine Ergebnisse gefunden.',
    'en-AU': 'No results found.',
    'en-CA': 'No results found.',
    'en-GB': 'No results found.',
    'en-SG': 'No results found.',
    'en-US': 'No results found.',
    'es-ES': 'No se han encontrado resultados.',
    'es-MX': 'No se encontraron resultados',
    'fr-CA': 'Aucun résultat trouvé.',
    'fr-FR': 'Aucun résultat trouvé.',
    'hi-IN': 'कोई परिणाम नहीं मिला.',
    'hu-HU': 'Nincsenek találatok.',
    'it-IT': 'Nessun risultato.',
    'ja-JP': '何も見つかりませんでした。',
    'lt-LT': 'Rezultatų nerasta.',
    'my-MM': 'ရလဒ်မတွေ့ပါ။',
    'ne-NP': 'कुनै नतिजाहरू फेला परेनन्।',
    'pl-PL': 'Nie znaleziono żadnych wyników.',
    'pt-BR': 'Nenhum resultado encontrado.',
    'ro-RO': 'Niciun rezultat găsit.',
    'ru-RU': 'Результаты не найдены.',
    'sk-SK': 'Nenašli sa žiadne výsledky.',
    'so-SO': 'Natiijada lama helin.',
    'tl-PH': 'Walang nahanap na resulta.',
    'tr-TR': 'Sonuç bulunamadı.',
    'uk-UA': 'Нічого не знайдено.',
    'ur-PK': 'کوئی نتیجہ نہیں ملا۔',
    'vi-VN': 'Không tìm thấy kết quả nào.',
    'zh-CN': '未找到任何结果。',
  },
  // https://lui.localization.amazon.dev/strings/167934
  select_all: {
    'ar-AE': 'تحديد الكل',
    'bn-IN': 'সব নির্বাচন করুন',
    'cs-CZ': 'Vybrat vše',
    'de-DE': 'Alle auswählen',
    'en-US': 'Select all',
    'es-ES': 'Seleccionar todo',
    'es-MX': 'Seleccionar todo',
    'es-US': 'Select all',
    'fr-CA': 'Sélectionner tout',
    'fr-FR': 'Sélectionner tout',
    'he-IL': 'בחירת הכל',
    'hi-IN': 'सभी चुनें',
    'it-IT': 'Seleziona tutto',
    'ja-JP': 'すべてを選択',
    'kn-IN': 'ಎಲ್ಲವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    'ko-KR': '모두 선택',
    'ml-IN': 'എല്ലാം തിരഞ്ഞെടുക്കുക',
    'mr-IN': 'सर्व निवडा',
    'nl-NL': 'Alles selecteren',
    'pl-PL': 'Wybierz wszystkie',
    'pt-BR': 'Selecionar tudo',
    'pt-PT': 'Selecionar tudo',
    'sv-SE': 'Markera alla',
    'ta-IN': 'அனைத்தையும் தேர்ந்தெடுக்கவும்',
    'te-IN': 'అన్నింటినీ ఎంచుకోండి',
    'tr-TR': 'Tümünü seç',
    'zh-CN': '全选',
    'zh-TW': '全選',
  },
  // https://lui.localization.amazon.dev/strings/565335
  pending_cancel: {
    'ar-AE': 'إلغاء',
    'bn-IN': 'বাতিল করুন',
    'cs-CZ': 'Zrušit',
    'de-DE': 'Abbrechen',
    'en-US': 'Cancel',
    'es-ES': 'Cancelar',
    'es-MX': 'Cancelar',
    'es-US': 'Cancelar',
    'fr-CA': 'Annuler',
    'fr-FR': 'Annuler',
    'he-IL': 'ביטול',
    'hi-IN': 'रद्द करें',
    'it-IT': 'Annulla',
    'ja-JP': 'キャンセル',
    'kn-IN': 'ರದ್ದು',
    'ko-KR': '취소',
    'ml-IN': 'റദ്ദാക്കുക',
    'mr-IN': 'रद्द करा',
    'nl-NL': 'Annuleren',
    'pl-PL': 'Anuluj',
    'pt-BR': 'Cancelar',
    'pt-PT': 'Cancelar',
    'sv-SE': 'Avbryt',
    'ta-IN': 'ரத்துசெய்',
    'te-IN': 'రద్దు చేయండి',
    'tr-TR': 'İptal',
    'zh-CN': '取消',
    'zh-TW': '取消',
  },
  // https://lui.localization.amazon.dev/strings/298
  pending_apply: {
    'ar-AE': 'تقديم',
    'bn-IN': 'প্রয়োগ করুন',
    'cs-CZ': 'Podat přihlášku',
    'de-DE': 'Anwenden',
    'en-US': 'Apply',
    'es-ES': 'Aplicar',
    'es-MX': 'Aplicar',
    'es-US': 'Aplicar',
    'fr-CA': 'Appliquer',
    'fr-FR': 'Appliquer',
    'he-IL': 'הגשת מועמדות',
    'hi-IN': 'लागू करें',
    'it-IT': 'Applica',
    'ja-JP': '適用',
    'kn-IN': 'ಅನ್ವಯಿಸಿ',
    'ko-KR': '신청',
    'ml-IN': 'അപേക്ഷിക്കുക',
    'mr-IN': 'लागू करा',
    'nl-NL': 'Toepassen',
    'pl-PL': 'Zastosuj',
    'pt-BR': 'Inscrever-se',
    'pt-PT': 'Aplicar',
    'sv-SE': 'Tillämpa',
    'ta-IN': 'பயன்படுத்து',
    'te-IN': 'వర్తింపజేయండి',
    'tr-TR': 'Başvur',
    'zh-CN': '应用',
    'zh-TW': '套用',
  },
};

export default katTranslator(strings);
